var indentStyle = {"indentZero":"_57WYp","indentOne":"iNKPE","indentTwo":"aeqwJ","indentThree":"T-yQe","indentFour":"VuqFl","indentFive":"Hk-nx","indentSix":"gIfcQ"};

export { indentStyle as i };
//# sourceMappingURL=indentation-1235154f.js.map
